import { getFiGrowthBook } from '../lib/growthbook';

/**
 * The redesigned cart and checkout, behind 'ecom-cart-checkout-v2'. Off, today's cart
 * (`HardwareFirstCartLegacy`) and checkout render.
 */
export default function useCartCheckoutV2(): boolean {
  return getFiGrowthBook().getFeatureValue<boolean>('ecom-cart-checkout-v2', false);
}
